/**
 * 视频封面：从本地视频文件截取首帧，上传后单独保存，不再混进图片列表
 */
// base64 转 Blob（部分低版本浏览器不支持 canvas.toBlob 时兜底）
export function dataURLtoBlob(dataurl) {
    var arr = dataurl.split(',')
    var mime = (arr[0].match(/:(.*?);/) || [])[1] || 'image/jpeg'
    var bstr = atob(arr[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    var n2 = n
    while (n2--) {
        u8arr[n2] = bstr.charCodeAt(n2)
    }
    return new Blob([u8arr], { type: mime })
}

/**
 * 截取视频首帧，返回 jpeg Blob
 * 说明：直接用本地文件截取，不依赖 OSS 视频截图，避免跨域/截图失败导致封面显示不出来
 * @param {File} file 视频文件
 * @returns {Promise<Blob>}
 */
export function captureVideoCover(file) {
    return new Promise((resolve, reject) => {
        if (!file || typeof URL === 'undefined' || !URL.createObjectURL) {
            reject(new Error('当前环境不支持截取视频封面'))
            return
        }
        var video = document.createElement('video')
        video.preload = 'auto'
        video.muted = true
        video.playsInline = true
        video.setAttribute('playsinline', '')
        video.setAttribute('webkit-playsinline', '')
        video.setAttribute('x5-video-player-type', 'h5')
        video.setAttribute('crossorigin', 'anonymous')
        var objectUrl = URL.createObjectURL(file)

        var finished = false
        var timer = setTimeout(function () {
            draw().then(done)
        }, 6000)

        function cleanup() {
            clearTimeout(timer)
            try {
                video.pause()
            } catch (e) {}
            video.removeAttribute('src')
            try {
                video.load()
            } catch (e) {}
            try {
                URL.revokeObjectURL(objectUrl)
            } catch (e) {}
        }

        function done(blob) {
            if (finished) return
            finished = true
            cleanup()
            if (blob) {
                resolve(blob)
            } else {
                reject(new Error('视频封面截取失败'))
            }
        }

        function draw() {
            return new Promise(function (res) {
                var w = video.videoWidth || 0
                var h = video.videoHeight || 0
                if (!w || !h) {
                    res(null)
                    return
                }
                // 封面尺寸压缩一下，避免原视频分辨率过大导致上传失败
                var maxSide = 720
                var scale = Math.min(1, maxSide / Math.max(w, h))
                var canvas = document.createElement('canvas')
                canvas.width = Math.round(w * scale)
                canvas.height = Math.round(h * scale)
                canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height)
                if (canvas.toBlob) {
                    canvas.toBlob(function (blob) {
                        res(blob)
                    }, 'image/jpeg', 0.8)
                } else {
                    res(dataURLtoBlob(canvas.toDataURL('image/jpeg', 0.8)))
                }
            })
        }

        function tryPlay() {
            try {
                var p = video.play()
                if (p && p.catch) p.catch(function () {})
            } catch (e) {}
        }

        video.addEventListener('loadeddata', function () {
            // 部分 iOS 需要先播放一下才能拿到画面
            tryPlay()
            if ((video.currentTime || 0) < 0.1) {
                try {
                    video.currentTime = 0.1
                } catch (e) {
                    draw().then(done)
                }
            } else {
                draw().then(done)
            }
        })
        video.addEventListener('seeked', function () {
            draw().then(function (blob) {
                if (blob) done(blob)
            })
        })
        video.addEventListener('timeupdate', function () {
            if (finished || (video.currentTime || 0) < 0.1) return
            draw().then(function (blob) {
                if (blob) done(blob)
            })
        })
        video.addEventListener('error', function () {
            done(null)
        })

        video.src = objectUrl
        try {
            video.load()
        } catch (e) {}
    })
}

/**
 * 把封面文件/Blob 转成可直接上传的 File
 * @param {Blob|File} file
 * @returns {File}
 */
export function coverToFile(file) {
    if (!file) return null
    if (typeof File !== 'undefined' && file instanceof File) return file
    try {
        return new File([file], 'cover.jpg', { type: 'image/jpeg' })
    } catch (e) {
        return file
    }
}
